import { setLocale } from 'helpers/locale'

export default {
  setLanguage: setLanguage
}

function setLanguage (lang) {
  setLocale(lang)
}



// WEBPACK FOOTER //
// ./src/services/lang/index.js